import React, { useState, useEffect } from 'react';
import { FlexWrapperCenter } from '../../styles/WrapperStyles';
import { BottomButton } from '../../styles/ButtonStyles';
import styled from 'styled-components';
import BaseModel from "../../BaseModal"
import { getDateWithTime } from "../../utils";
import urls from '../../api/urls.json'
import Loader from '../Loader';
import { authorizedHttpGet } from '../../api/httpCalls';


const ParentDiv = styled.div`
  width: 645px;
  max-height: 450px;
  border-radius: 20px;
  overflow-y: auto;
`;

const TextView = styled.p`
  font-family: 'Gilory-Semi';
  font-size: 16px;
  font-weight: 600;
  color: #484848;
  margin: 0;
`;

const TitleView = styled.div`
  font-family: 'Gilroy-Bold';
  font-size: 30px;
  font-weight: 800;
  color: #484848;
  text-align: center;
  margin-bottom: 12px;
`;

const BottomButtonBase = styled(BottomButton)`
  margin: 16px auto 20px;
  display: block;
`;

const Card = styled.div`
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  background: #fafafa;
  padding: 14px 16px;
  margin: 0 8px 12px;
`;

const MetaRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px;
  margin-bottom: 10px;
`;

const Field = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
`;

const Label = styled.div`
  font-size: 11px;
  font-family: 'Gilory-Semi';
  color: #7b7b7b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const ControlsRow = styled.div`
  display: flex;
  align-items: end;
  gap: 12px;
  margin: 0 8px 16px;
`;

const DateInput = styled.input`
  width: 180px;
  height: 42px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 0 12px;
  font-family: 'Gilory-Semi';
  font-size: 14px;
  color: #484848;
`;

const ClearButton = styled.button`
  height: 42px;
  padding: 0 16px;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  font-family: 'Gilory-Semi';
  font-size: 14px;
  color: #484848;
`;

const DateHint = styled.span`
  align-self: center;
  font-family: 'Gilory-Semi';
  font-size: 13px;
  color: #7b7b7b;
`;

function ActivityModal(props) {
    const [list, setList] = useState([]);
    const [showProgress, setShowProgress] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [selectedDate, setSelectedDate] = useState('');
    const shouldShowDateFilter = [
        'likes_sent',
        'invites_sent',
        'replies_sent',
        'user_passed',
        'sparks_sent',
        'sparks_received',
        'sparks_received_accepted',
        'sparks_received_rejected',
        'sparks_sent_accepted',
        'sparks_sent_rejected'
    ].includes(props.filter);
    const isSentActivity = [
        'likes_sent',
        'sparks_sent',
        'sparks_sent_accepted',
        'sparks_sent_rejected',
        'invites_sent',
        'replies_sent',
        'invites_sent_accepted',
        'invites_sent_passed',
        'user_passed',
        'blocked_self'
    ].includes(props.filter);

    useEffect(() => {
        setList([]);
        setCurrentPage(1);
        setTotalPage(1);
        setSelectedDate('');
        getUser(1, '');
    }, [props.filter, props.user_ref]);

    const getUser = async (page = 1, date = selectedDate) => {
        setShowProgress(true);
        const queryParams = { page: page, filter: props.filter, ref: props.user_ref };
        if (date) {
            queryParams.date = date;
        }
        let response = await authorizedHttpGet(urls.GET_ACTIVITY, queryParams);
        const responseData = response?.data || {};
        if (response.status) {
            if (Array.isArray(responseData.list)) {
                if (page === 1) {
                    setList(responseData.list);
                } else {
                    setList((prevList) => [...prevList, ...responseData.list]);
                }
                setCurrentPage(responseData.page || page);
                setTotalPage(responseData.total_pages || page);
            }
        }
        setShowProgress(false);
    }

    const handleDateChange = (event) => {
        const nextDate = event.target.value;
        setSelectedDate(nextDate);
        setList([]);
        setCurrentPage(1);
        setTotalPage(1);
        getUser(1, nextDate);
    };

    const clearDateFilter = () => {
        setSelectedDate('');
        setList([]);
        setCurrentPage(1);
        setTotalPage(1);
        getUser(1, '');
    };

    return (
        <>
            {showProgress && <Loader loading={showProgress} />}
            <BaseModel closeModal={() => props.closeModal()}>

                <ParentDiv>
                    {props.title ? (
                        <FlexWrapperCenter>
                            <TitleView>{props.title}</TitleView>
                        </FlexWrapperCenter>
                    ) : null}
                    {shouldShowDateFilter ? (
                        <ControlsRow>
                            <Field style={{ margin: 0, flex: '0 0 auto' }}>
                                <Label>Date</Label>
                                <DateInput type="date" value={selectedDate} onChange={handleDateChange} />
                            </Field>
                            {selectedDate ? <ClearButton type="button" onClick={clearDateFilter}>Clear</ClearButton> : null}
                            {!selectedDate ? <DateHint>Showing all dates</DateHint> : null}
                        </ControlsRow>
                    ) : null}
                    {list.map((item, pos) => (
                        <Card key={pos}>
                            <MetaRow>
                                <Field>
                                    <Label>Date</Label>
                                    <TextView>{getDateWithTime(item.date)}</TextView>
                                </Field>
                                <Field>
                                    <Label>From</Label>
                                    <TextView>
                                        {isSentActivity ? item.to_ref : item.from_ref}{' '}
                                        {isSentActivity ? item.to_name : item.from_name}
                                    </TextView>
                                    {(isSentActivity ? item.to_profile_state : item.from_profile_state) ? (
                                        <TextView>{isSentActivity ? item.to_profile_state : item.from_profile_state}</TextView>
                                    ) : null}
                                </Field>
                                <Field>
                                    <Label>To</Label>
                                    <TextView>
                                        {isSentActivity ? item.from_ref : item.to_ref}{' '}
                                        {isSentActivity ? item.from_name : item.to_name}
                                    </TextView>
                                    {(isSentActivity ? item.from_profile_state : item.to_profile_state) ? (
                                        <TextView>{isSentActivity ? item.from_profile_state : item.to_profile_state}</TextView>
                                    ) : null}
                                </Field>
                            </MetaRow>
                            {item.report_option ? (
                                <Field style={{ marginBottom: '8px' }}>
                                    <Label>Reason</Label>
                                    <TextView>{item.report_option}</TextView>
                                </Field>
                            ) : null}
                            {item.note ? (
                                <Field>
                                    <Label>Note</Label>
                                    <TextView>{item.note}</TextView>
                                </Field>
                            ) : null}
                            {item.spark_id ? (
                                <MetaRow style={{ marginBottom: 0 }}>
                                    <Field>
                                        <Label>Spark Id</Label>
                                        <TextView>{item.spark_id}</TextView>
                                    </Field>
                                    <Field>
                                        <Label>Status</Label>
                                        <TextView>{item.status}</TextView>
                                    </Field>
                                    <Field>
                                        <Label>Type</Label>
                                        <TextView>{item.sparks_type}</TextView>
                                    </Field>
                                </MetaRow>
                            ) : null}
                        </Card>
                    ))}
                    {currentPage < totalPage && !showProgress ? (
                        <BottomButtonBase onClick={() => getUser(currentPage + 1)}>Load More</BottomButtonBase>
                    ) : null}
                </ParentDiv>
            </BaseModel>
        </>
    );
}

export default ActivityModal;
